export { memoryCreateCommand } from './v1/memory_create';

import { memoryCreateCommand } from './v1/memory_create';

export const memoryCommands = [memoryCreateCommand];
